<div class="tm-picker" [class.tm-picker--compact]="compact">
  <!-- Organisation type: presets the modules below -->
  <p class="tm-picker__label" [id]="typesLabelId">{{ "tenantModules.OrganisationType" | translate }}</p>
  <div class="tm-types" role="radiogroup" [attr.aria-labelledby]="typesLabelId">
    <button
      type="button"
      class="tm-type"
      *ngFor="let o of typeOptions"
      role="radio"
      [attr.aria-checked]="o.type === type"
      [attr.data-tenant-type]="o.type"
      [class.is-selected]="o.type === type"
      [disabled]="disabled"
      (click)="selectType(o)">
      <span class="tm-type__icon"><i [ngClass]="o.icon" aria-hidden="true"></i></span>
      <span class="tm-type__body">
        <span class="tm-type__title">{{ o.labelKey | translate }}</span>
        <span class="tm-type__hint" *ngIf="!compact">{{ o.hintKey | translate }}</span>
        <span class="tm-type__chips">
          <span class="tm-chip" *ngFor="let m of o.modules">{{ moduleLabelKey(m) | translate }}</span>
        </span>
      </span>
      <i class="bi bi-check-circle-fill tm-type__check" *ngIf="o.type === type" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Modules: what the school actually uses -->
  <p class="tm-picker__label">{{ "tenantModules.Modules" | translate }}</p>
  <ul class="tm-modules">
    <li
      class="tm-module"
      *ngFor="let o of moduleOptions"
      [class.is-on]="isOn(o.module)"
      [class.is-blocked]="isBlocked(o.module)"
      [attr.data-module]="o.module">
      <span class="tm-module__icon"><i [ngClass]="o.icon" aria-hidden="true"></i></span>
      <div class="tm-module__body">
        <label class="tm-module__title" [for]="idFor(o.module)">{{ o.labelKey | translate }}</label>
        <span class="tm-module__hint">{{ o.hintKey | translate }}</span>
        <span class="tm-module__blocked" *ngIf="isBlocked(o.module)">
          <i class="bi bi-lock-fill" aria-hidden="true"></i>
          {{ "tenantModules.BlockedByPlan" | translate }}
        </span>
      </div>
      <div class="form-check form-switch m-0 tm-module__switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          [id]="idFor(o.module)"
          [checked]="isOn(o.module)"
          [disabled]="disabled || isBlocked(o.module)"
          (change)="toggle(o.module, $event)" />
      </div>
    </li>
  </ul>

  <p class="tm-picker__error" *ngIf="modules.length === 0" role="alert">
    <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
    {{ "tenantModules.AtLeastOne" | translate }}
  </p>
</div>
